// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"related-legal-understanding_wrapper__JcQs9","heading":"related-legal-understanding_heading__7cW3p","snippet":"related-legal-understanding_snippet__fAiC_"};